import moment from 'moment'
import {IUserGroup} from '../models/Base'
import {DynamicFieldValueDto} from '../models/dto/Commons'
import { convertFromRaw } from 'draft-js'
import {stateToHTML} from 'draft-js-export-html'

export function instanceOf<T>(object: any, prop: string): object is T {
  return prop in object
}

export function catchErrorMsg(ex: any): string {
  return ex.response?.data?.Message ? ex.response.data.Message : 'Unexpected error.'
}

export function GetTime(date: Date) {
  return new Date(date).getTime()
}

export function BuildDateTime(date: Date, time: number) {
  const datetime = new Date(
    `${moment(date).format('YYYY-MM-DD')}T${moment(time).format('HH:mm:ss')}`
  )
  return ResoveTimeZone(datetime)
}

export function ResoveTimeZone(datetime: Date) {
  const userTimezoneOffset = datetime.getTimezoneOffset() * 60000
  const d = new Date(datetime.getTime() - userTimezoneOffset)
  return d
}

export function DateDiff(date1: Date, date2: Date) {
  const a = moment(date1)
  const b = moment(date2)
  return a.diff(b)
}

export function CurrentDate() {
  return ResoveTimeZone(new Date())
}

export function addDays(date: Date, days: number) {
  var result = new Date(date)
  result.setDate(result.getDate() + days)
  return result
}
export function addMonths(date: Date, month: number) {
  var result = new Date(date)
  result.setMonth(result.getMonth() + 1 + month)
  return result
}

export function getType<T>(TCtor: new (...args: any[]) => T): string {
  // get type of T
  const type = typeof TCtor
  return type
  // ...
}
export function GetDynamicFieldValue(
  values: DynamicFieldValueDto[] | null,
  propId: number
): string {
  if (!values) return ''
  const obj = values.find((x) => x.dynamicFieldPropertyId === propId)
  return obj ? obj.value : ''
}

export function pad(num: number, size: number) {
  return ('000000000' + num).substr(-size)
}

export function GetBadgeActive(value: boolean) {
  return `badge badge-light-${value ? 'success' : 'danger'}`
}



export function replaceAt(str: string, index: number, replacement: string) {
  return str.substring(0, index) + replacement + str.substring(index + replacement.length)
}

export function stringToBoolean(stringValue: any) {
  switch (stringValue?.toString().toLowerCase()?.trim()) {
    case 'true':
    case 'yes':
    case '1':
      return true

    case 'false':
    case 'no':
    case '0':
    case null:
    case undefined:
      return false

    default:
      return false
  }
}

export function FormatMoney(amount?: number) {
  if (!amount) return 0.0
  return amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
}

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export const getLongMonthName = function (date: Date) {
  return monthNames[date.getMonth()]
}

export const getShortMonthName = function (date: Date) {
  return monthNames[date.getMonth()].substring(0, 3)
}

export const getMonthNameById = function (month: number) {
  return monthNames[month].substring(0, 3)
}

 


export function timeToString(time:number) {
  if (time < 0)
    time = 0;
  var hrs = ~~(time / 3600 % 24),
    mins = ~~((time % 3600) / 60),
    timeType = (hrs > 11 ? "PM" : "AM");
  if (hrs > 12)
    hrs = hrs - 12;
  if (hrs === 0)
    hrs = 12;
  return hrs + ":" + mins +' '+ timeType;
}

export function totalTime(time:number){
  const hh = Math.floor(time / 1000 / 60 / 60);   
  const hhStr = ('0' + hh).slice(-2)
 
  time -= hh * 1000 * 60 * 60;
  const mm = Math.floor(time / 1000 / 60);
  const mmStr = ('0' + mm).slice(-2)

  time -= mm * 1000 * 60;
  const ss = Math.floor(time / 1000);
  const ssStr = ('0' + ss).slice(-2)
  
  return  `${hhStr} H ${mmStr} Min.`;

}

export function toHtml(content: string) {
  if (content === '') return ''
  const dataToReplace: any[] = []
  const stateContent = JSON.parse(content)
  Object.keys(stateContent).forEach((key, index) => {
    if (key === 'entityMap') {
      Object.keys(stateContent[key]).forEach((key1, index) => {
        if (stateContent[key][key1].type === 'IMAGE')
          dataToReplace.push(stateContent[key][key1].data)
      })
    }
  })
  let contentState = convertFromRaw(JSON.parse(content))
  let html = stateToHTML(contentState)
  html = replaceAlignHtml(html, dataToReplace)
  return html
}
export function replaceAlignHtml(html: string, sources: any[]) {
  for (let index = 0; index < sources.length; index++) {
    if (sources[index].hasOwnProperty('alignment')) {
      html = html.replace(
        '<img src="' + sources[index].src + '"/>',
        "<div style='text-align:" +
          sources[index].alignment +
          '\'><img src="' +
          sources[index].src +
          '"/></div>'
      )
    }
  }
  return html
}